import createApi from 'api/createApi';
import qs from 'query-string';

const stringify = (body) => qs.stringify(body, { arrayFormat: 'bracket' });

export const tags = {
	themesList: 'mw/knowledge-base-themes/list',
	themeDetail: 'mw/knowledge-base-themes/detail',
	themeRate: 'mw/knowledge-base-themes/rate',
	themeComment: 'mw/knowledge-base-themes/comment',
	themePostComment: 'mw/knowledge-base-themes/comment/post',
};

export const knowledgeBaseThemesApi = createApi({
	reducerPath: 'mw/knowledgeBaseThemesApi',
	tagTypes: Object.values(tags),
	endpoints: (builder) => ({
		themesList: builder.query({
			query: () => ({
				method: 'GET',
				url: '/mw/knowledge-base-themes',
			}),
			providesTags: [tags.themesList],
			transformResponse: (response) => ({
				result: response,
			}),
		}),
		themeDetail: builder.query({
			query: (themeId) => ({
				method: 'GET',
				url: `/mw/knowledge-base-themes/${themeId}`,
			}),
			providesTags: [tags.themeDetail],
			transformResponse: (response) => ({
				result: response,
			}),
		}),
		themeRate: builder.mutation({
			query: ({ id, ...body }) => ({
				method: 'POST',
				url: `/mw/knowledge-base-themes/${id}/rate`,
				body,
				jsonType: true,
			}),
			invalidatesTags: [tags.themeDetail],
		}),
		themeComment: builder.query({
			query: ({ id, ...body }) => ({
				method: 'GET',
				url: `/mw/knowledge-base-themes/${id}/comment?${stringify(body)}`,
			}),
			providesTags: [tags.themeComment],
		}),
		themeReply: builder.query({
			query: ({ id, commentId, ...body }) => ({
				method: 'GET',
				url: `/mw/knowledge-base-themes/${id}/comment/${commentId}/replies?${stringify(body)}`,
			}),
			providesTags: [tags.themeComment],
		}),
		themePostComment: builder.mutation({
			query: ({ id, ...body }) => ({
				method: 'POST',
				url: `/mw/knowledge-base-themes/${id}/comment`,
				body,
				jsonType: true,
			}),
			invalidatesTags: [tags.themeComment],
		}),
	}),
});

export const {
	themesList,
	themeDetail,
	themeRate,
	themeComment,
	themeReply,
	themePostComment,
} = knowledgeBaseThemesApi.endpoints;

export default knowledgeBaseThemesApi;
